module.exports = __webpack_public_path__ + "img/icon-acciones.1075fa95.svg";